var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnactus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.47 491.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #b8b8b8;\n      }\n\n      .cls-4 {\n        fill: #8f8f8f;\n      }\n\n      .cls-5 {\n        fill: #c3c3c3;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-11 {\n        fill: #202020;\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 306.23,
    y: 265.25,
    width: 24.6,
    height: 55.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.77,
    y: 276.73,
    width: 40.45,
    height: 44.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 229.7,
    y: 276.73,
    width: 37.72,
    height: 44.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.6,
    y: 276.73,
    width: 34.99,
    height: 44.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.28,
    y: 276.73,
    width: 35.5,
    height: 44.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.64,
    y: 277.27,
    width: 39.36,
    height: 43.61
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m181.15,232.23l14.96,15.52h-33.19l18.23-15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.58,247.76h7.91l9.67-15.52-17.57,15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m125.23,288.93l-38.77-40.23h45.26l-6.49,40.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.34,248.7h-13.42l5.32,40.23,8.1-40.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m306.23,265.54h10.74v12.27h13.47c0,2.27.08,4.55.08,6.82h-13.55c0,8.01.26,17.47.26,24.75,0,.59.47,1.08.76,1.59,1.06,1.81,3.83,1.83,6.99,1.62.34,2.98.34,4.51.6,7.24-12.41,3.57-19.35-3.66-19.35-9.72v-44.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m153.15,294.82c6.36,0,13.41.04,19.77.04.09-13.08-19.94-12.48-19.77-.04Zm29.66,7.54h-29.66c2.05,12.28,14.89,10.75,26.02,8.49.64,2.92,1.14,4.74,1.86,7.74-21.15,6.47-39.32-1.68-38.1-21.69.75-12.25,9.5-19.55,20.41-19.9,9.33-.29,18.84,6.69,19.39,17.17.13,2.38.04,5.33.09,8.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m225.26,320.08h-10.14c0-7.92.09-17.87.09-25.48,0-3.34-3.4-9.69-8.27-8.78-4.09.77-9.63,3.58-10.14,9.8-.34,7.33-.26,17.3-.26,24.46h-9.81v-42.27c3.41,0,6.49.09,9.89.09v5.88c3.55-2.36,9.37-8.36,19.43-6.48,6.21,2.07,9.01,8.2,9.01,15.87,0,8.41.19,18.5.19,26.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m241.38,311.22c5.69,4.41,16.75,1.14,15-8.18-7.95-.52-19.01-1.06-15,8.18Zm25.5,8.86h-10.23v-4.42c-4.84,5.99-14.35,6.41-20.71,2.81-6.82-3.87-8.1-13.81-2.74-19.52,4.4-4.69,13.29-3.07,23.18-3.41,1.89-14.4-14.16-9.88-23.51-9.62-.25-3.32-.17-4.35-.35-7.42,11.73-1.76,25-3.83,31.04,4.01,1.87,2.43,3.52,5.37,3.52,8.77,0,8.27-.14,18.76-.2,28.81"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m304.24,278.41c-.26,2.73-.85,5.2-1.39,7.58-15.74-4-23.28,5.16-22.39,14.32.82,8.48,8.86,15.25,21.9,10.91.6,1.96,1.54,4.69,1.88,6.99-16.62,7.65-32.89-2.01-34.11-17.22-1.41-17.5,13.58-28.34,34.11-22.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m405.06,279.17c-.47,3.33-.64,4.26-1.36,7.5-5.42-.67-20.79-4.68-20.45,1.36.46,8.36,28.94,7.3,22.62,24.3-3.77,10.13-23.58,10.13-34.21,4.34.46-2.38.88-4,2.05-6.82,5.92,1.37,22.33,6.23,22.5-1.36.12-5.54-17.7-7.57-21.13-12.96-8.92-13.97,9.41-23.35,30-16.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m329.22,277.81h10.6c0,7.84-.17,18.86-.17,26.59,0,3.63,2.16,6.43,5.25,6.81,6.93.86,12.08-3.24,12.39-10.39.3-6.93.2-15.66.17-23.01h10.23c0,14.09.09,28.18.09,42.27h-10.14v-6.81c-3.5,5.54-14.24,10.82-22.5,5.2-4.18-2.84-5.55-7.88-5.88-13.89-.45-8.15-.03-17.9-.03-26.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m125.85,177.24l-.7,111.73,56-56.73-55.31-55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnactus);
export default __webpack_public_path__ + "static/media/enactus.c47843ece1b640335069d7033d4edb96.svg";
export { ForwardRef as ReactComponent };